import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";

export class Registration {
	constructor(public store: IIncentiveV2Store) {
	}
}